<template>
	<v-modal>
		<template v-slot:header>
			<h1>About the fittings & contents form (TA10)</h1>
		</template>
		<template v-if="showBack" v-slot:back>
			<button class="v-modal__header__actions__back" @click.prevent="$vmodal.back()">About protocol packs</button>
		</template>
		<section>
			<header class="mt-2">
				<h1 class="beta heavy">Instructions</h1>
			</header>
			<div class="editorial mt-2">
				<p>In each row, the seller should tick the appropriate box to show whether:</p>
				<ul>
					<li>there is no such item at the property ('None');</li>
					<li>the item is included in the sale ('Included');</li>
					<li>the item is for sale ('For Sale').</li>
				</ul>
				<p>Where an item is not included in the sale the seller may offer it for sale by inserting a price in the appropriate box. The buyer can then decide whether to accept the seller's offer.</p>
				<p>A seller who inserts a price in this form is responsible for negotiating the sale of that item directly with the buyer or through their estate agent. If the seller or buyer instructs their solicitor to negotiate the sale of such an item, there may be an additional charge.</p>
				<p>Sellers and buyers should inform their solicitors of any arrangements made about items offered for sale.</p>
				<p>If the seller removes any fixtures, fittings or contents, the seller should be reasonably careful to ensure that any damage caused is minimised.</p>
				<p>Unless stated otherwise, the seller will be responsible for ensuring that all rubbish is removed from the property (including from the loft, garden, outbuildings, garages and sheds), and that the property is left in a reasonably clean and tidy condition.</p>
			</div>
		</section>
		<section>
			<header class="mt-2">
				<h1 class="beta heavy">Definitions</h1>
			</header>
			<div class="editorial mt-2">
				<ul>
					<li>'Seller' means all sellers together where the property is owned by more than one person.</li>
				</ul>
			</div>
		</section>
	</v-modal>
</template>
<script>
export default {
	props: {
		showBack: {
			required: false,
			type: Boolean,
			default() {
				return false;
			},
		},
	},
};
</script>
